// Contract between SideNav's chat buttons and the view that owns the drawers (CommandCenter.vue).
//
//   SideNav  ──chat-open {kind}──▶  host view opens the matching drawer
//   host view ──chat-unread n────▶  SideNav shows the badge
//
// Also keeps a "pending" intent: if the user clicks Chat from another route, SideNav navigates
// to the dashboard first; the host consumes the pending kind in mounted() because the bus
// event can fire before it has subscribed.

import bus from "@/helpers/appBus.js"

export const CHAT_OPEN_EVENT = "chat-open"
export const CHAT_UNREAD_EVENT = "chat-unread"
export const CHAT_KIND_SWIFT = "swiftchat"
export const CHAT_KIND_LOANLAUNCH = "loanlaunch"

let pending = null

export function requestOpenChat(kind) {
  pending = kind
  bus.emit(CHAT_OPEN_EVENT, kind)
}

// Host calls this in mounted(). Returns the kind (and clears it) or null.
export function consumePendingChat() {
  const k = pending
  pending = null
  return k
}

export function publishChatUnread(n) {
  bus.emit(CHAT_UNREAD_EVENT, Number(n) || 0)
}
